export const CUSTOMER_ADDRESS_MAX_LENGTH = 255;
export const CUSTOMER_NAME_MAX_LENGTH = 50;
